import React from "react";
import Helmet from "react-helmet";
const MetaData = ({
  fields,
  pageFields,
  canonicalUrl,
  origin
}) => {
  const makeImageLinkedInCompatible = imageUrl => {
    /*
    LinkedIn share cards don't support webp images, so we need to remove the extension from the url if it exists
    The first replace caters for when extension is one of many key value pairs in a list - e.g domain?extension=webp&otherParam=123 or domain?otherParam=123&extension=webp&otherParam2=456
    The second caters for when extension is the final key value pair of many in list - e.g domain?otherParam=123&extension=webp
    The third caters for when extension is the only key value pair - e.g domain?extension=webp
    */
    const webpExtension = "extension=webp";
    return imageUrl.replace(`${webpExtension}&`, "").replace(`&${webpExtension}`, "").replace(`?${webpExtension}`, "");
  };
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("title", null, pageFields?.BrowserTitle?.value || "Page"), pageFields?.MetaDescription?.value && /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: pageFields.MetaDescription.value
  }), pageFields?.MetaKeywords?.value && /*#__PURE__*/React.createElement("meta", {
    name: "keywords",
    content: pageFields.MetaKeywords.value
  }), pageFields?.Robots?.fields?.Directive?.value && /*#__PURE__*/React.createElement("meta", {
    name: "robots",
    content: pageFields.Robots.fields.Directive.value
  }), origin && pageFields?.CanonicalUrl?.value?.href && /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: canonicalUrl
  }), (pageFields?.ogTitle?.value || pageFields?.Title?.value) && /*#__PURE__*/React.createElement("meta", {
    property: "og:title",
    content: pageFields?.ogTitle?.value || pageFields?.Title?.value
  }), (pageFields?.ogDescription?.value || pageFields?.MetaDescription?.value) && /*#__PURE__*/React.createElement("meta", {
    property: "og:description",
    content: pageFields?.ogDescription?.value || pageFields?.MetaDescription?.value
  }), pageFields?.ogImage?.value?.src && /*#__PURE__*/React.createElement("meta", {
    property: "og:image",
    content: makeImageLinkedInCompatible(pageFields.ogImage.value.src)
  }), pageFields?.ogUrl?.value && /*#__PURE__*/React.createElement("meta", {
    property: "og:url",
    content: pageFields.ogUrl.value
  }), pageFields?.ogType?.value && /*#__PURE__*/React.createElement("meta", {
    property: "og:type",
    content: pageFields.ogType.value
  }), fields?.FacebookDomainVerification?.value && /*#__PURE__*/React.createElement("meta", {
    name: "facebook-domain-verification",
    content: fields.FacebookDomainVerification.value
  }), (pageFields?.ogTitle?.value || pageFields?.Title?.value) && /*#__PURE__*/React.createElement("meta", {
    name: "twitter:title",
    content: pageFields?.ogTitle?.value || pageFields?.Title?.value
  }), (pageFields?.ogDescription?.value || pageFields?.MetaDescription?.value) && /*#__PURE__*/React.createElement("meta", {
    name: "twitter:description",
    content: pageFields?.ogDescription?.value || pageFields?.MetaDescription?.value
  }), pageFields?.ogImage?.value?.src && /*#__PURE__*/React.createElement("meta", {
    name: "twitter:image",
    content: pageFields.ogImage.value.src
  }), fields?.TwitterSite?.value && /*#__PURE__*/React.createElement("meta", {
    name: "twitter:site",
    content: fields.TwitterSite.value
  }), fields?.TwitterCreator?.value && /*#__PURE__*/React.createElement("meta", {
    name: "twitter:creator",
    content: fields.TwitterCreator.value
  }), pageFields?.twitterCard?.fields?.Card?.value && /*#__PURE__*/React.createElement("meta", {
    name: "twitter:card",
    content: pageFields.twitterCard.fields.Card.value
  }));
};
export default MetaData;